import React from 'react';
import { PageShell } from '../components/PageShell';
import { StoreLayout } from '../components/StoreLayout';
import { ChampionShirtAccess } from '../components/ChampionShirtAccess';
import { ChampionShirtPurchase } from '../components/ChampionShirtPurchase';
import { useSession } from '../contexts/SessionContext';
import { images } from '../data/site';
const PRODUCT_NAME = 'League Champions Shirt';
export function ChampionShirt() {
  const {
    isLoggedIn,
    championEligible
  } = useSession();
  if (!isLoggedIn || !championEligible) {
    return <PageShell showChampionBanner={false} data-id="element-255" data-mp="7wxhr21djtw2">
        <div className="flex min-h-[480px] items-start justify-center px-6 py-16" data-id="element-256" data-mp="3q5etw8ay93a9">
          <ChampionShirtAccess variant={isLoggedIn ? 'unavailable' : 'loginRequired'} data-id="element-257" data-mp="3u5ynj1wbdorn" />
        </div>
      </PageShell>;
  }
  return <PageShell showChampionBanner={false} data-id="element-258" data-mp="1oel7p26ghnta">
      <StoreLayout category="Championship" productName={PRODUCT_NAME} data-id="element-259" data-mp="1sevcwcmfca73">
        <article className="grid gap-10 px-7 py-10 xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-260" data-mp="1se2ebyxmcr01">
          <div data-id="element-261" data-mp="3bfll2vrs54u9">
            <h2 className="text-center font-condensed text-4xl font-semibold uppercase tracking-tight text-[#3A3A6A]" data-id="element-262" data-mp="3bf2179ikk6dl">{PRODUCT_NAME}</h2>
            <img src={images.championShirt} alt="Royal blue League Champions shirt" className="mx-auto mt-6 w-full max-w-[560px]" data-id="element-263" data-mp="3l7rd25i17m9g" />
          </div>
          <div className="xl:pt-16" data-id="element-264" data-mp="3g8wr4uorphl4">
            <ChampionShirtPurchase data-id="element-265" data-mp="2siaj33erjxb4" />
          </div>
        </article>
      </StoreLayout>
    </PageShell>;
}